import { CircleAlert, CircleCheck } from "lucide-react";
import formatPhone from "../utils/formatPhoneForUser";
import { Button } from "./ui/button";
import { Card } from "./ui/card";

export function SubmissionMessage(props) {
  const isOptInMissing =
    props.apiErrorMessage === "You have not opted in to SMS messages.";

  const businessName = props.businessName || " ";
  const isLongBusinessName = businessName.length > 25;

  return (
    <>
      {props.apiError ? (
        isOptInMissing ? (
          <Card className="w-full p-5 shadow-lg sm:p-8">
            <h1
              className={`mb-2.5 break-words text-center font-extrabold leading-[1.1] tracking-tight sm:mb-4 ${
                isLongBusinessName
                  ? "text-[2rem] sm:text-[2.4rem]"
                  : "text-4xl sm:text-[2.75rem]"
              }`}
            >
              {businessName}
            </h1>
            <div className="mx-auto max-w-[50ch] whitespace-pre-line text-center text-sm leading-snug text-muted-foreground sm:text-base">
              {props.apiErrorMessage}
            </div>
            <p className="mt-6 text-center text-xs text-muted-foreground sm:text-sm">
              Returning to form{" "}
              <span aria-hidden="true" className="inline-flex">
                <span className="animate-bounce [animation-delay:-0.3s]">.</span>
                <span className="animate-bounce [animation-delay:-0.15s]">.</span>
                <span className="animate-bounce">.</span>
              </span>
            </p>
          </Card>
        ) : (
          <div className="my-2 flex w-full flex-col items-center text-center">
            <CircleAlert color={props.errorColor} size={90} />
            <h3 className="break-words py-4 text-3xl font-semibold sm:text-4xl">
              {props.apiErrorMessage}
            </h3>
            <Button
              variant="ghost"
              onClick={() => {
                props.resetInputs();
                props.setIsSubmitted(false);
              }}
            >
              Go back
            </Button>
          </div>
        )
      ) : (
        <div className="my-2 flex w-full flex-col items-center text-center">
          <CircleCheck color="green" size={90} />
          <h2 className="mt-2 text-6xl font-extrabold tracking-tight text-brand-dark sm:text-7xl md:text-8xl">
            Thank You
          </h2>
          <p className="py-4 text-lg sm:text-xl">
            You should receive a text from +1{" "}
            {formatPhone(props.twilioNumber)}
          </p>
          <Button
            variant="ghost"
            className="h-auto whitespace-normal py-2"
            onClick={() => {
              props.resetInputs();
              props.setIsSubmitted(false);
            }}
          >
            Don't see a text? Click here to try again.
          </Button>
        </div>
      )}
    </>
  );
}

export default SubmissionMessage;
